import React, { useEffect,useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Login() {
    const [form, setForm] = useState({ rfc: '', username: '', password: '' });
    const navigate = useNavigate();

    const enviarDatos = async (datos) => {
        //console.log(datos);
        try {
            const response = await fetch('https://web.sconline.mx/chat_api/v1/auth/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(datos)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const resultado = await response.json();

            //console.log('Login exitoso:', resultado);

            if (resultado != null) {
                if (resultado.success === true) {
                    localStorage.setItem('isLoggedIn', 'true');
                    localStorage.setItem('user', JSON.stringify(resultado)); // Guarda los datos del usuario
                    localStorage.setItem('session', JSON.stringify(resultado.session));
                    navigate('/home', { replace: true });
                } else {
                    alert('Credenciales incorrectas');
                }

            }

            // Aquí puedes guardar el token en localStorage si lo necesitas
            // localStorage.setItem('token', resultado.token);

        } catch (error) {
            console.error('Error enviando datos:', error);
            alert('Error de autenticación. Revisa tus credenciales.');
            localStorage.setItem('isLoggedIn', 'false');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (form.username && form.password && form.rfc) {
            await enviarDatos(form);
        } else {
            alert('Completa todos los campos');
        }
    };

    useEffect(() => {
            const handlePopState = (event) => {
                // Si el usuario intenta ir atrás, lo mantenemos en /home
                navigate('/', { replace: true });
            };
    
            window.addEventListener('popstate', handlePopState);
    
            return () => {
                window.removeEventListener('popstate', handlePopState);
            };
        }, [navigate]);
    return (
        <div style={styles.container}>
            <form onSubmit={handleSubmit} style={styles.form}>
                <img
                    src="/Contalog.svg"
                    alt="Logo"
                    style={styles.logo}
                />
                <input
                    name="rfc"
                    placeholder="RFC"
                    value={form.rfc}
                    onChange={handleChange}
                    style={styles.input}
                />
                <input
                    name="username"
                    placeholder="Usuario"
                    value={form.username}
                    onChange={handleChange}
                    style={styles.input}
                />
                <input
                    name="password"
                    type="password"
                    placeholder="Contraseña"
                    value={form.password}
                    onChange={handleChange}
                    style={styles.input}
                />
                <button type="submit" style={styles.button}>Entrar</button>
            </form>
        </div>
    );
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundImage: 'url("/fondohd.jpg")',
        backgroundSize: 'cover',         
        backgroundPosition: 'center',    
        backgroundRepeat: 'no-repeat'    
    },
    title: {
        marginBottom: 20,
    },
    form: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 12,
        backgroundColor: '#f8f8f8',
        height: '400px',
        width: '300px',
        border: '2px solid #EDD378',
        borderRadius: "24px"
    },
    input: {
        padding: 10,
        fontSize: '16px',
    },
    button: {
        padding: 10,
        backgroundColor: '#222D63',
        color: 'white',
        border: '2px solid #A69245',
        fontSize: '16px',
        borderRadius: '20px',
    },
    logo: {
    width: '180px',
    height: 'auto',
    marginBottom: '20px',
}
};

export default Login;
